import { type } from 'jquery';
import { SET_PACKAGE_COUNT, ADD_PACKAGE, REMOVE_PACKAGE, UPDATE_PACKAGE, SET_UPLOAD_PROGRESS, RESET_PACKAGE, SET_INITIAL_PACKAGES, SET_REFERENCE_PACKAGES, SET_PACKAGE_DIMENSION_UNIT, RESET_PACKAGE_DIMENSIONS, SET_EDIT_PACKAGE_BTN } from './actionTypes';

// set the number of packages
export const setPackageCount = (count) => ({
  type: SET_PACKAGE_COUNT,
  payload: count,
});

// add a new package
export const addPackage = () => ({
  type: ADD_PACKAGE,
});

// remove a package by index
export const removePackage = (index) => ({
  type: REMOVE_PACKAGE,
  payload: index,
});

// update a package's details by index
export const updatePackage = (index, updatedPackages) => {
  return({
  type: UPDATE_PACKAGE,
  payload: { index, updatedPackages },
  }
  )
};

export const resetPackages = () => ({
  type:RESET_PACKAGE
})

export const setInitialPackages = (pkgs) => ({
  type:SET_INITIAL_PACKAGES,
  payload:pkgs
})

// update the upload progress
export const setUploadProgress = (index,progress) => ({
  type: SET_UPLOAD_PROGRESS,
  payload: {index,progress},
});

export const setReferencePackage = (packages) => ({
  type:SET_REFERENCE_PACKAGES,
  payload:packages
})

export const setPackageDimensionUnit = (unit) => ({
  type: SET_PACKAGE_DIMENSION_UNIT,
  payload: unit
});

export const resetPackageDimensions = (index) => ({
  type: RESET_PACKAGE_DIMENSIONS,
  payload: index,
});

export const setEditBtn = (value) => ({
  type:SET_EDIT_PACKAGE_BTN,
  payload:value
})
